// import { NgModule } from '@angular/core';
// import { Routes, RouterModule } from '@angular/router';
// // import { StyleguideCameraComponent } from './extra/styleguide-camera/styleguide-camera.component';
// import { SelfieComponent } from './selfie/selfie.component';

// const routes: Routes = [
// 	{ path: '', redirectTo: 'selfie', pathMatch: 'full', data: { title: 'Selfie' } },
// 	{ path: 'selfie', component: SelfieComponent, data: { title: 'Selfie' } },

// 	// { path: 'styleguide', component: StyleguideCameraComponent, data: { title: 'styleguide' } }
// ];

// @NgModule({
// 	imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
// 	exports: [RouterModule]
// }) 
// export class AppRoutingModule { }


import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SelfieComponent } from './selfie/selfie.component';

const routes: Routes = [
  { path: '', redirectTo: 'selfie', pathMatch: 'full', data: { title: 'Selfie' } },
  { path: 'selfie', component: SelfieComponent, data: { title: 'Selfie' } },
  { path: '**', redirectTo: 'selfie' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }